module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Material Estimator")]), _vm._v(" "), _c('div', {
    staticClass: "columns estimator"
  }, [_c('div', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Project Details")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Material Type")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.selectedMaterial
    },
    on: {
      "change": function($event) {
        _vm.selectedMaterial = $event.target.value
      }
    }
  }, _vm._l((_vm.materials), function(material, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(material.name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Area Shape")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.selectedArea
    },
    on: {
      "change": function($event) {
        _vm.selectedArea = $event.target.value
      }
    }
  }, _vm._l((_vm.areas), function(area, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(area.name))])
  }), 0)])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Area Dimensions")]), _vm._v(" "), _vm._l((_vm.areaDimensions), function(dimension, index) {
    return _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v(_vm._s(dimension.name))]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dimensions[index].value),
        expression: "dimensions[index].value"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": dimension.name
      },
      domProps: {
        "value": (_vm.dimensions[index].value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dimensions[index], "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      domProps: {
        "value": _vm.dimensions[index].unit
      },
      on: {
        "change": function($event) {
          _vm.dimensions[index].unit = $event.target.value
        }
      }
    }, _vm._l((_vm.units), function(unit, index) {
      return _c('option', {
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(unit.name))])
    }), 0)])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.materials[_vm.selectedMaterial].name) + " Estimate:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "is-large results"
  }, [_vm._v("\n                    Your project has an area of "), _c('strong', [_vm._v(_vm._s(Math.round((_vm.results.area / 12 / 108) * _vm.precision) / _vm.precision))]), _vm._v(" square yards.\n                    "), _c('br'), _vm._v("\n                    You will need roughly\n                    "), _c('strong', [_vm._v(_vm._s(_vm.results.yards))]), _vm._v("\n                    cubic yards of " + _vm._s(_vm.materials[_vm.selectedMaterial].name) + ".\n                    "), _c('br'), _vm._v("\n                    This weighs about\n                    "), _c('strong', [_vm._v(_vm._s(Math.round((_vm.results.yards * _vm.materials[_vm.selectedMaterial].poundsPerYard / 2000) * _vm.precision) / _vm.precision))]), _vm._v(" tons\n                    (or "), _c('strong', [_vm._v(_vm._s(Math.round((_vm.results.yards * _vm.materials[_vm.selectedMaterial].poundsPerYard) * _vm.precision) / _vm.precision))]), _vm._v(" pounds).\n\n                    "), _c('div', {
    staticClass: "area-shape"
  }, [(_vm.selectedArea === 'rectangle') ? _c('img', {
    attrs: {
      "src": require("../assets/shapes/rectangle.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'rectangleborder') ? _c('img', {
    attrs: {
      "src": require("../assets/shapes/rectangleborder.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'circle') ? _c('img', {
    attrs: {
      "src": require("../assets/shapes/circle.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'triangle') ? _c('img', {
    attrs: {
      "src": require("../assets/shapes/triangle.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'circleborder') ? _c('img', {
    attrs: {
      "src": require("../assets/shapes/circleborder.svg")
    }
  }) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Material weight reference (per cubic yard)")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('strong', [_vm._v("Please note:")]), _vm._v(" "), _c('br'), _vm._v("\n                    This is an estimate planning tool "), _c('u', [_vm._v("only")]), _vm._v("\n                    and the real world values required for your project may\n                    differ from the values determined here. Material weight can vary according to the batch, moisture conditions,\n                    and other variables not accounted for in this estimate. Always be sure to double check your measurements\n                    and err on the side of more material rather than less before starting your project.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Bark Mulch *")]), _vm._v(" "), _c('td', [_vm._v("600-800 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cypress Mulch *")]), _vm._v(" "), _c('td', [_vm._v("600-800 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Soil Mixes *")]), _vm._v(" "), _c('td', [_vm._v("1300-1650 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gravel *")]), _vm._v(" "), _c('td', [_vm._v("2500-2600 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Decomposed Granite *")]), _vm._v(" "), _c('td', [_vm._v("2600 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sand *")]), _vm._v(" "), _c('td', [_vm._v("2800 Lbs.")])])])]), _vm._v(" "), _c('em', [_vm._v("* weight varies by moisture content and grain or chip size")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-772b9e11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calculator.vue
// module id = 163
// module chunks = 1